import { Moon, Sun } from "lucide-react";
import { Button } from "../ui/button";
import { useTheme } from "../../hooks/useTheme";

interface ThemeToggleProps {
  /** true quando renderizado no rodape do Nav (botao quadrado so-icone,
   * fundo coral — handoff: tema fica sempre icon-only ali, aberto ou
   * recolhido; so o bloco de usuario ao lado some quando recolhido). */
  rail?: boolean;
}

export function ThemeToggle({ rail }: ThemeToggleProps = {}): JSX.Element {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Mudar para tema claro" : "Mudar para tema escuro";

  if (rail) {
    // Contexto: rodape do menu lateral (fundo coral, botao quadrado 2rem).
    return (
      <button type="button" className="nav__foot-btn" onClick={toggle} aria-label={label} title={label}>
        {isDark ? <Sun className="icon" aria-hidden /> : <Moon className="icon" aria-hidden />}
      </button>
    );
  }

  return (
    <Button variant="ghost" size="icon" onClick={toggle} aria-label={label} title={label}>
      {isDark ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />}
    </Button>
  );
}
